export const environment = {
    production: true,
    apiPath: "https://prod2.api.plsrvw.net",
    version: "10",
    typeApp: "WIDGETS",
};
